import React, { useContext } from 'react';
import Row from 'react-bootstrap/Row';
import { isNullOrUndefined } from 'util';
import { OverviewContext } from '../../context/OverviewProvider';
import { LabelText } from '../../../components/Language';
import Aux from '../../../hoc/Auxiliary';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {OverviewDetailsOptions} from '../../../common/const/OverviewDetailsOptions';
import HeaderTitle from '../../../hoc/HeaderTitle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport, faPencilAlt, faSave, faFilter, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import './index.css';
import '../index.css';

export default function OverviewDetailHeader(props) {

  const { overviewDetails, handlerOnExportToExcelClick, selectedOverdetailsOption, handlerOnClearFilterClick
          , isDetailsFilterApplied, dataError} = useContext(OverviewContext);
  const isEditAccess = props.isEditAccess;
  const isEnable = props.isEnableEditableFields;
  const isSubmittedRevenue = selectedOverdetailsOption === OverviewDetailsOptions.submittedRevenue;

  const onEditClick = () => {
    if(props.isEditBtnToggle === true)
    {
      props.handlerOnEditBtnClick();
    }
    else
    {
      props.handlerOnEditBtnToggleClick(dataError && dataError.size > 0 ? true : false);
    }
  }
   
  const showInstructions = () => {
    props.showInstructionsHandler(true);
  }

  const helpTooltip = (
    <Tooltip id="helpIcon">
      <LabelText tid="help" />
    </Tooltip>
  )

  const editTooltip = (
    <Tooltip id="editIcon">
      <LabelText tid="edit" />
    </Tooltip>
  )
  const saveTooltip = (
    <Tooltip id="saveIcon">
      <LabelText tid="save" />
    </Tooltip>
  )
  const exportTooltip = (
    <Tooltip id="exportIcon">
      <LabelText tid="export" />
    </Tooltip>
  )

  const clearFilterTooltip = (
    <Tooltip id="clearFilterIcon">
      <LabelText tid={isDetailsFilterApplied ? "clearfilter" : "inactivefilter"} />
    </Tooltip>
  )


  const onSaveClick = () => {
    let error = "";
    let isUpdated = false;
    let isError = false;
    let updateDetailRequestModel = null;

    if (dataError && dataError.size > 0)
    {
      error = Array.from(dataError)[dataError.size-1][1]
      isError = true ;
    }
    else
    {
    overviewDetails && overviewDetails.nmbsUserDetailOverviewDtos && overviewDetails.nmbsUserDetailOverviewDtos.map((d, index) => {
      if (d.isUpdated) {       
        isUpdated = d.isUpdated;
        if (error.trim() === "")
            {
              error = checkRevenueData(d);
              isError = error ?  true : false;
            }        
      }     
    });
    }

    if (error.trim() === "" && isUpdated === false) {
      error = "nodata";
      isError = true;
    }

    if (error.trim() === "") {       
      updateDetailRequestModel = overviewDetails && overviewDetails.nmbsUserDetailOverviewDtos
        .reduce((arr, item, index) => {
          if (item.isUpdated)
            arr.push({
              "businessPartnerId": item.businessPartnerId,
              "contractId": item.contractId,
              "revenueId": item.revenueId,
              "isShopOpen": item.isShopOpen === "Yes",
              "soldTicket": +item.soldTicket.replace(/\./g, ""),
              "modifiedBy": props.UserId, // NOTE: This need to check after login integration
              "revenueWithTaxAmount": convertToNumber(item.revenueWithTaxAmount),
              "revenueWithoutTaxAmount": convertToNumber(item.revenueWithoutTaxAmount),
              "remarksId": +item.remarksId
            })
          return arr;
        }
          , []);     
    } 
    props.handlerOnSaveClick(isError, error, updateDetailRequestModel); 
  }

  function convertToNumber(revenueAmount) {
    const tax_0 = Number((revenueAmount.tax_0.replace(/\./g, "")).replace(/\,/g, "."));
    const tax_6 = Number((revenueAmount.tax_6.replace(/\./g, "")).replace(/\,/g, "."));
    const tax_12 = Number((revenueAmount.tax_12.replace(/\./g, "")).replace(/\,/g, "."));
    const tax_21 = Number((revenueAmount.tax_21.replace(/\./g, "")).replace(/\,/g, "."));

    return {
      "tax_0": tax_0,
      "tax_6": tax_6,
      "tax_12": tax_12,
      "tax_21": tax_21
    }
  }

  const checkIfNullOrUndefined = (fieldValue) => {
    return isNullOrUndefined(fieldValue) || fieldValue === "";
  }

  const checkIfAmountIsZero = (amountValue) => {
    return  amountValue!=="" && amountValue !== "0" && amountValue !== "0,00"
  }

  function checkRevenueData(revenueData) {   
    
    if (checkIfNullOrUndefined(revenueData.revenueWithTaxAmount.tax_0)||
    (checkIfNullOrUndefined(revenueData.revenueWithTaxAmount.tax_6))||
    (checkIfNullOrUndefined(revenueData.revenueWithTaxAmount.tax_12))||
    (checkIfNullOrUndefined(revenueData.revenueWithTaxAmount.tax_21))||
    (checkIfNullOrUndefined(revenueData.soldTicket)))
      return "mandatory"
    else if ((!revenueData.tax_0_IsValid) || (!revenueData.tax_6_IsValid) || (!revenueData.tax_12_IsValid)
      || (!revenueData.tax_21_IsValid) || (!revenueData.soldTicket_IsValid))    
      {
        return "nodata";       
      }
    else if (revenueData.isShopOpen === "No") {
        if (checkIfAmountIsZero(revenueData.revenueWithTaxAmount.tax_0) || checkIfAmountIsZero(revenueData.revenueWithTaxAmount.tax_6)
          || checkIfAmountIsZero(revenueData.revenueWithTaxAmount.tax_12) || checkIfAmountIsZero(revenueData.revenueWithTaxAmount.tax_21)
          || revenueData.soldTicket !== "0") { return "shop_openstatus"; }         
    }    
    else if (revenueData.revenueWithTaxAmount && (checkIfAmountIsZero(revenueData.revenueWithTaxAmount.tax_0) || checkIfAmountIsZero(revenueData.revenueWithTaxAmount.tax_6) ||
              checkIfAmountIsZero(revenueData.revenueWithTaxAmount.tax_12) || checkIfAmountIsZero(revenueData.revenueWithTaxAmount.tax_21)) && 
              (revenueData.soldTicket === "0" || revenueData.soldTicket === 0)) {          
          return "soldticketvalidation1";
    } else if (revenueData.revenueWithTaxAmount && (!checkIfNullOrUndefined(revenueData.revenueWithTaxAmount.tax_0) && 
                  !checkIfNullOrUndefined(revenueData.revenueWithTaxAmount.tax_6) &&
                  !checkIfNullOrUndefined(revenueData.revenueWithTaxAmount.tax_12) && 
                  !checkIfNullOrUndefined(revenueData.revenueWithTaxAmount.tax_21) &&
                  !checkIfAmountIsZero(revenueData.revenueWithTaxAmount.tax_0) && 
                  !checkIfAmountIsZero(revenueData.revenueWithTaxAmount.tax_6) &&
                  !checkIfAmountIsZero(revenueData.revenueWithTaxAmount.tax_12) && 
                  !checkIfAmountIsZero(revenueData.revenueWithTaxAmount.tax_21)) && 
                  (revenueData.soldTicket !== "0" && revenueData.soldTicket !== 0)) { 
        return "soldticketvalidation2";  
      }   
    return "";
  }
  
  return (    
    <Aux>
      <div className="OverviewDetail-header-main">
      <HeaderTitle className = "OverviewDetail-header-col row">
        <span className="Title-align">
          <LabelText tid={isSubmittedRevenue ? "detailoverview" : "detail_overview_unsubmitted"} />
        </span>
      </HeaderTitle>      
      <Row className="OverviewDetail-btn-row">
      <div className="empty-div"/>
      <OverlayTrigger placement="bottom" overlay={exportTooltip}>
          <div role="button" tabIndex="0" title="Export to excel button"
               disabled={!props.isOverviewDetailsAvailable} onClick={handlerOnExportToExcelClick}
               onKeyDown={(e) => { if (e.key === "Enter") handlerOnExportToExcelClick()}} >
            <FontAwesomeIcon className={props.isOverviewDetailsAvailable ? "ExportButton" :
             "ExportButton disable-icon" } icon= {faFileExport} />
          </div>
        </OverlayTrigger>        
        {isEditAccess && isSubmittedRevenue &&
          <>
          <div className="empty-div"/>
          <OverlayTrigger placement="top" overlay={editTooltip}>
          <div role="button" tabIndex="0" title="Edit button" 
              disabled={!props.isOverviewDetailsAvailable} onClick={onEditClick}
              onKeyDown={(e) => { if (e.key === "Enter") onEditClick()}} >
                 <FontAwesomeIcon className = {props.isOverviewDetailsAvailable ? 
                          props.isEditBtnToggle ? "EditButton" : "EditButton EditButton-Enable"
                           : "EditButton disable-icon" } icon= {faPencilAlt} />
          </div>
        </OverlayTrigger>
        </>
      }
        
        {isEditAccess && isSubmittedRevenue &&
        <>
          <div className="empty-div"/>
           <OverlayTrigger placement="bottom" overlay={saveTooltip}>
          <div role="button" tabIndex="0" title="Save button"          
            disabled={!isEnable} onClick={(e) => { if(isEnable) onSaveClick() } } 
            onKeyDown={(e) => { if (e.key === "Enter") onSaveClick()}}>
            <FontAwesomeIcon className = {isEnable ? "SaveButton" : "SaveButton disable-icon"} icon= {faSave} />
          </div>
        </OverlayTrigger>
        </>}
        <div className="empty-div"/>
        <OverlayTrigger placement="top" overlay={clearFilterTooltip}>
          <div role="button" tabIndex="0" title= {isDetailsFilterApplied ? "Clear filter" : "Inactive Filter"}              
               disabled={!props.isOverviewDetailsAvailable} onClick={()=>isDetailsFilterApplied
                 && handlerOnClearFilterClick(true)}
               onKeyDown={(e) => { e.key === "Enter" 
               && isDetailsFilterApplied && handlerOnClearFilterClick(true)}} >
              <FontAwesomeIcon className = { props.isOverviewDetailsAvailable ? 
                    (isDetailsFilterApplied ? (isSubmittedRevenue ? "FilterButton ActiveFilterButtonSubmitted" 
                    : "FilterButton ActiveFilterButtonUnSubmitted") : (isSubmittedRevenue ?  "FilterButton InActiveFilterButtonSubmitted": 
                    "FilterButton InActiveFilterButtonUnSubmitted")): "FilterButton InActiveFilterButton disable-icon" } icon= {faFilter} />
          </div>
        </OverlayTrigger>  
        {isSubmittedRevenue && 
        <>
          <div className="empty-div"/>
          <OverlayTrigger placement="bottom" overlay={helpTooltip}>
          <div role="button" tabIndex="0" title="Help button" onClick={showInstructions}
          onKeyDown={(e) => { if (e.key === "Enter") showInstructions()}} >
           <FontAwesomeIcon className="HelpButton" icon= {faInfoCircle} /> 
          </div>        
        </OverlayTrigger>
        </>}
      </Row>
      </div>
    </Aux>       
  );
}